import { ImageAttachmentData } from "~/models/card";
import { Tag } from "~/models/list";
import { buildUrl } from "~/utils/url";
import { addBaseUrlToTags } from "~/utils/tags";
import { ItemDescription } from "~/common/list/ItemDescription";
import { ItemHeader } from "~/common/list/ItemHeader";
import { FundItemFooterImage } from "./FundItemFooterImage";

interface FundItemCardProps {
  baseUrl: string;
  ein: string;
  name: string;
  rating?: number;
  starRating: number;
  image?: ImageAttachmentData;
  city?: string;
  state?: string;
  tags?: Tag[];
  description?: string;
}

export function FundItemCardImage({
  baseUrl,
  ein,
  name,
  rating,
  starRating,
  image,
  city,
  state,
  tags,
  description,
}: FundItemCardProps) {
  return (
    <div
      onClick={() => {
        window.location.href = buildUrl(baseUrl, `/ein/${ein}`);
      }}
      className="tw:min-w-[300px] tw:my-4 tw:md:my-0 tw:block tw:w-full tw:max-w-[400px] tw:bg-white tw:rounded-[20px] tw:lg:rounded-3xl tw:!border tw:!border-gray-300/60 tw:!shadow-[8px_8px_16px_0_rgba(166,171,189,0.1)] tw:p-5 tw:hover:cursor-pointer"
      aria-label="nonprofit profile page"
    >
      <div className="tw:flex tw:flex-col tw:justify-between tw:h-full">
        <ItemHeader
          name={name}
          city={city}
          state={state}
          tags={addBaseUrlToTags(tags, baseUrl)}
        />

        <div>
          <ItemDescription description={description} />

          <FundItemFooterImage
            rating={rating}
            starRating={starRating}
            image={image}
          />
        </div>
      </div>
    </div>
  );
}
